import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CountdownTimer } from "../../countdown-timer/countdown-timer";
import {
  mobileHeaderStyles,
  mobileInfoTextStyles,
} from "../../live-speech-screen/styles";
import {
  roleplayPhoneLandscapeMedia,
  videoTimerOverlayStyles,
} from "./styles";

interface AvatarHeaderInfoProps {
  showCountdown: boolean;
  realtimePersona: { text: string } | null;
  realtimeMaturityLevel: string | null;
  lessonSecondsAllowed: number | null;
  lessonSecondsRemaining: number | null;
  isConnected: boolean;
  liveSpeechMode: string | null;
  onTimeUp: () => void;
  hidePersonaOverlay?: boolean;
}

export const AvatarHeaderInfo: React.FC<AvatarHeaderInfoProps> = ({
  showCountdown,
  realtimePersona,
  realtimeMaturityLevel,
  lessonSecondsAllowed,
  lessonSecondsRemaining,
  isConnected,
  liveSpeechMode,
  onTimeUp,
  hidePersonaOverlay = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isPhoneLandscape = useMediaQuery(roleplayPhoneLandscapeMedia);
  const timerSize = isPhoneLandscape ? 36 : isMobile ? 40 : 80;

  return (
    <>
      {!showCountdown && !hidePersonaOverlay && (
        <Box sx={mobileHeaderStyles}>
          {realtimePersona && (
            <Typography sx={mobileInfoTextStyles}>
              {realtimePersona.text}
            </Typography>
          )}
          {realtimeMaturityLevel && (
            <Typography sx={mobileInfoTextStyles}>
              {realtimeMaturityLevel}
            </Typography>
          )}
        </Box>
      )}

      {lessonSecondsAllowed &&
        lessonSecondsRemaining &&
        !showCountdown &&
        isConnected &&
        liveSpeechMode !== "coach_me" && (
          <Box sx={videoTimerOverlayStyles}>
            <CountdownTimer
              totalSeconds={lessonSecondsAllowed}
              remainingSeconds={lessonSecondsRemaining}
              onTimeUp={onTimeUp}
              size={timerSize}
              color="#1976d2"
              textColor="#ffffff"
            />
          </Box>
        )}
    </>
  );
};
